import React, {useContext} from 'react';
import {FormGroup, FormText, Input} from 'reactstrap';
import {useFormContext} from 'react-hook-form';
import {FormFieldProps} from '@src/@types/components/Form';
import RequiredFieldSign from '../RequiredFieldSign';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import FormErrorMessage from '../FormErrorMessage';
import Translate from '@src/components/Translate/Translate';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import classnames from '@src/helpers/classnames';
import TriggerableField from '../utils/TriggerableField';

export default function CheckboxField<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    const {register, getFieldState, formState} = useFormContext<Model>();
    const [design] = useContext(FormFieldDesignContext);

    const id = `${props.formName}@${props.fieldName}`;
    const isInvalid = Boolean(getFieldState(props.fieldName as any, formState).error);

    const {ref, ...inputProps} = register(props.fieldName as any);

    return <FormGroup
            className={classnames({
                'form-check': true,
                [design.wrapperClass]: design.wrapperClass,
                [props.config.spanClass ?? '']: props.config.spanClass,
                [props.className ?? '']: props.className,
                'd-none': props.config.hidden === true,
            })}
            {...(props.config.containerAttributes ?? {})}
    >
        <TriggerableField
                trigger={props.config.trigger}
                componentToRender={Input}
                type="checkbox"
                {...inputProps}
                {...(props.config.attributes ?? {})}
                innerRef={ref}
                invalid={isInvalid}
                bsSize={props.config.size || design.size}
                id={id}
                readOnly={props.config.readOnly === true || design.fieldsAreReadOnly || props.forceReadonly}
                disabled={props.config.disabled === true || design.fieldsAreDisabled || props.forceDisabled}
        />
        <label className="form-check-label" htmlFor={id}>
            <Translate
                    {...props.config}
                    message={props.fieldLabel}
                    tag={RequiredFieldSign}
            />
        </label>

        {props.config.comment ? <div><Translate message={props.config.comment} tag={FormText}/></div> : null}

        <FormErrorMessage fieldName={props.fieldName as string}/>
    </FormGroup>;
}
